import { BaseFieldComponent } from '../base-field/base-field.component';
import { Component, forwardRef, OnInit } from '@angular/core';
import { GeolocalizationDialogComponent } from './no-geolocation-dialog/no-geolocation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'forms-localization',
  templateUrl: './localization.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LocalizationComponent),
      multi: true,
    },
  ],
  })
export class LocalizationComponent extends BaseFieldComponent implements OnInit {
  readonly geolocateMeText = 'Lokalizuj\u00A0\u2316';
  positionText: string = 'Nie udało się ustalić lokalizacji';
  showControl: boolean = false;

  constructor(private dialog: MatDialog) {
    super();
  }

  ngOnInit() {
    this.getCurrentPosition(() => {
      this.showControl = true;
      this.form.controls[this.formField.id].markAsTouched();
    });
  }

  getCurrentPosition(onFailure?: () => void): void {
    if (navigator.geolocation) {
      const options: PositionOptions = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 60000,
      };

      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.positionText = this.convertDDToDMS(position.coords);

          this.writeValue({
            lat: position.coords.latitude,
            lon: position.coords.longitude,
          });
        },
        (error) => {
          if (onFailure) {
            onFailure();
          }

          this.dialog
            .open(GeolocalizationDialogComponent, {
              data: error,
            })
            .afterClosed()
            .subscribe((retry) => {
              if (retry) this.getCurrentPosition();
            });
        },
        options,
      );
    } else {
      if (onFailure) {
        onFailure();
      }

      this.dialog.open(GeolocalizationDialogComponent, {
        data: { code: -1 },
      });
    }
  }

  private convertDDToDMS(coords: { latitude: number; longitude: number }): string {
    return `\uD83D\uDDFA ${this.convertDegreeToDMS(coords.latitude)} ${this.convertDegreeToDMS(coords.longitude, true)}`;
  }

  private convertDegreeToDMS(D: number, isLongitude: boolean = false): string {
    const dir = D < 0 ? (isLongitude ? 'W' : 'S') : isLongitude ? 'E' : 'N';
    const deg = 0 | (D < 0 ? (D = -D) : D);
    const min = 0 | (((D += 1e-9) % 1) * 60);
    const sec = (0 | (((D * 60) % 1) * 6000)) / 100;

    return `${deg}°${min}'${sec}"${dir}`;
  }
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_forms/projects/forms/src/lib/components/controls/localization/localization.component.ts